export default function TestimonialSection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="relative bg-foreground-950 rounded-2xl overflow-hidden">
          <div className="flex flex-col lg:flex-row">
            <div className="lg:w-2/5 relative">
              <div className="h-72 lg:h-full">
                <img
                  src="https://readdy.ai/api/search-image?query=Confident%20stylish%20person%20wearing%20smart%20casual%20outfit%20standing%20against%20a%20textured%20concrete%20wall%2C%20natural%20window%20light%20from%20left%2C%20warm%20olive%20and%20terracotta%20tones%2C%20fashionable%20urban%20aesthetic%2C%20genuine%20smile%2C%20editorial%20portrait%20photography%2C%20modern%20lifestyle%20vibe&width=600&height=800&seq=testimonial-v2-portrait&orientation=portrait"
                  alt="ACBuy Spreadsheet user testimonial"
                  title="Satisfied ACBuy Spreadsheet user"
                  className="w-full h-full object-cover object-top"
                  loading="lazy"
                />
              </div>
            </div>

            <div className="lg:w-3/5 flex items-center p-8 md:p-12 lg:p-16">
              <div>
                <span className="font-heading text-6xl md:text-8xl text-accent-500/40 leading-none select-none">
                  &ldquo;
                </span>
                <p className="text-base md:text-lg lg:text-xl text-background-50 leading-relaxed -mt-6 md:-mt-8">
                  The <strong className="text-accent-400">acbuyspreadsheet database</strong> completely
                  changed how I shop online. I used to spend hours opening dozens of tabs just to compare
                  prices across different stores. Now everything is organized in one place — the spreadsheet
                  layout makes comparisons instant. I have saved at least 30% on my last five orders and
                  discovered products I would have completely missed otherwise.
                </p>
                <div className="mt-6 md:mt-8">
                  <p className="text-background-50 font-semibold text-sm">Marcus Chen</p>
                  <p className="text-background-50/50 text-xs mt-0.5">
                    Verified ACBuy Spreadsheet User · Frequent Shopper
                  </p>
                </div>
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="inline-flex items-center gap-2 mt-6 px-6 py-2.5 bg-accent-500 text-foreground-950 rounded-full text-sm font-semibold hover:bg-accent-400 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                >
                  Try ACBuy Spreadsheet
                  <i className="ri-arrow-right-up-line"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}